import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "grid gap-x-5 gap-y-6 grid-cols-2 w-3/4" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-2 flex flex-col gap-y-2"
}
const _hoisted_3 = { class: "rounded-2xl border border-gray-lp-1600 divide-y divide-gray-lp-1600 text-black-lp-300" }
const _hoisted_4 = { class: "grid grid-cols-4 p-3 gap-x-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-row gap-2 overflow-x-auto" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex flex-row gap-2 overflow-x-auto" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex flex-row justify-between" }
const _hoisted_12 = { class: "pt-6" }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_PopupDetailKoli = _resolveComponent("PopupDetailKoli")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('Detail Pengiriman')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      (_ctx.isCargoPlaneManual)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.isValidAwb)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Kota asal'),
                    value: 
            `${_ctx.formBooking.originCityCode} - ${_ctx.formBooking.originCityName}`
          
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Kota tujuan'),
                    value: 
            `${_ctx.formBooking.destinationCityCode} - ${_ctx.formBooking.destinationCityName}`
          
                  }, null, 8, ["label", "value"]),
                  (_ctx.formBooking.awbTracking?.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, [
                        _createVNode(_component_Title, {
                          label: _ctx.$t('Detail Pengiriman'),
                          fontSize: 14
                        }, null, 8, ["label"]),
                        _createVNode("div", _hoisted_3, [
                          _createVNode("div", _hoisted_4, [
                            _createVNode(_component_Title, {
                              label: _ctx.$t('Nomor penerbangan'),
                              fontSize: 12
                            }, null, 8, ["label"]),
                            _createVNode(_component_Title, {
                              label: _ctx.$t('Tanggal keberangkatan'),
                              fontSize: 12
                            }, null, 8, ["label"]),
                            _createVNode(_component_Title, {
                              label: _ctx.$t('Estimasi keberangkatan/\u200Bkedatangan'),
                              fontSize: 12,
                              class: "break-words"
                            }, null, 8, ["label"]),
                            _createVNode(_component_Title, {
                              label: _ctx.$t('Rute'),
                              fontSize: 12
                            }, null, 8, ["label"])
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formBooking.awbTracking, (item) => {
                            return (_openBlock(), _createBlock("div", {
                              key: item.flightNumber,
                              class: "grid grid-cols-4 p-3 gap-x-8"
                            }, [
                              _createVNode(_component_Title, {
                                label: item.flightNumber,
                                fontSize: 12,
                                bold: "normal"
                              }, null, 8, ["label"]),
                              _createVNode(_component_Title, {
                                label: item.flightDate,
                                fontSize: 12,
                                bold: "normal"
                              }, null, 8, ["label"]),
                              _createVNode(_component_Title, {
                                label: `${item.etd} / ${item.eta}`,
                                fontSize: 12,
                                bold: "normal"
                              }, null, 8, ["label"]),
                              _createVNode(_component_Title, {
                                label: `${item.origin} - ${item.destination}`,
                                fontSize: 12,
                                bold: "normal"
                              }, null, 8, ["label"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Bandara asal'),
                    value: _ctx.formBooking.airportOrigin.name
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Bandara tujuan'),
                    value: _ctx.formBooking.airportDestination.name
                  }, null, 8, ["label", "value"])
                ], 64))
              : _createCommentVNode("", true),
            (!_ctx.isValidAwb)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: _ctx.$t('No. Penerbangan'),
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      onChange: _ctx.onChangeVehicleNumber,
                      modelValue: _ctx.formBooking.vehicleNumber,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formBooking.vehicleNumber = $event)),
                      placeholder: _ctx.$t('Masukan nomor penerbangan')
                    }, null, 8, ["onChange", "modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: "Komoditas kargo",
              value: _ctx.formBooking.cargoCommodityName
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              label: "Produk kargo",
              asterisk: !_ctx.isValidAwb,
              value: _ctx.formBooking.cargoProduct
            }, {
              default: _withCtx(() => [
                (!_ctx.isValidAwb)
                  ? (_openBlock(), _createBlock(_component_Select, {
                      key: 0,
                      onOpenSelect: _ctx.onOpenSelectCargoProduct,
                      onCloseSelect: _ctx.onCloseSelectCargoProduct,
                      isOpenMenu: _ctx.isOpenSelectCargoProduct,
                      value: _ctx.formBooking.cargoProduct,
                      onChooseSelect: _ctx.onSelectCargoProduct,
                      dataSelect: _ctx.listProductCargo,
                      customClass: "w-full",
                      class: "w-full whitespace-no-wrap my-2 z-10"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["asterisk", "value"]),
            (!_ctx.isValidAwb)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: "Nature of Goods (NOG)",
                  optional: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      onChange: _ctx.onChangeNog,
                      modelValue: _ctx.formBooking.nog,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formBooking.nog = $event)),
                      placeholder: _ctx.$t('Masukan NOG')
                    }, null, 8, ["onChange", "modelValue", "placeholder"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total berat kotor kargo aktual'),
              value: `${_ctx.convertDecimal(_ctx.formBooking.actualTotalCargoGrossWeight)} kg`
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total berat volume kargo aktual'),
              value: 
          `${_ctx.convertDecimal(_ctx.formBooking.actualTotalCargoVolumeWeight)} kg`
        
            }, null, 8, ["label", "value"])
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.isProcessFromRTC)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: "Komoditas Kargo",
                  class: `${_ctx.isCargoPlaneAuto ? '' : 'col-span-2'} pr-6`,
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CustomDropdown, {
                      class: "my-1.5 w-1/2",
                      placeholder: "Pilih komoditas",
                      options: _ctx.commodityOptions,
                      onSelect: _ctx.onSelectCommodity,
                      selectedItem: _ctx.commodityItem,
                      isCustomWidth: ""
                    }, null, 8, ["options", "onSelect", "selectedItem"])
                  ]),
                  _: 1
                }, 8, ["class"]))
              : (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: _ctx.$t('Komoditas Kargo'),
                  class: `${_ctx.isCargoPlaneAuto ? '' : 'col-span-2'}`,
                  value: _ctx.formBooking.cargoCommodityName
                }, null, 8, ["label", "class", "value"])),
            (_ctx.isCargoPlaneAuto)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: "SHC",
                  value: _ctx.shcValue
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.isCargoTruck)
              ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Produk Kargo'),
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Select, {
                        onOpenSelect: _ctx.onOpenSelectCargoProduct,
                        onCloseSelect: _ctx.onCloseSelectCargoProduct,
                        isOpenMenu: _ctx.isOpenSelectCargoProduct,
                        value: _ctx.formBooking.cargoProduct,
                        onChooseSelect: _ctx.onSelectCargoProduct,
                        dataSelect: _ctx.listProductCargo,
                        customClass: "w-full",
                        class: "w-full whitespace-no-wrap my-2 z-10"
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('No. Seri Kendaraan'),
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpInput, {
                        onChange: _ctx.onChangeVehicleNumber,
                        modelValue: _ctx.formBooking.vehicleNumber,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formBooking.vehicleNumber = $event)),
                        placeholder: _ctx.$t('Masukan No. seri kendaraan')
                      }, null, 8, ["onChange", "modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Bukti Foto perubahan berat')
                  }, {
                    default: _withCtx(() => [
                      (_ctx.photoProof.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_5, [
                            _createVNode("div", _hoisted_6, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.photoProof, (photo, index) => {
                                return (_openBlock(), _createBlock("button", {
                                  key: index,
                                  class: "relative flex flex-col p-1 items-center justify-center rounded-xl bg-gray-lp-1000",
                                  style: {"width":"40px","height":"40px"}
                                }, [
                                  _createVNode("img", {
                                    src: photo,
                                    class: "h-full w-full object-cover rounded",
                                    alt: "result-image"
                                  }, null, 8, ["src"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_7, " - "))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.isProcessFromRTC)
              ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Dimensi",
                    suffix: "P x L x T",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputDimension, {
                        class: "my-1.5",
                        length: _ctx.formBooking.actualDimension.length,
                        "onUpdate:length": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formBooking.actualDimension.length = $event)),
                        width: _ctx.formBooking.actualDimension.width,
                        "onUpdate:width": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formBooking.actualDimension.width = $event)),
                        height: _ctx.formBooking.actualDimension.height,
                        "onUpdate:height": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formBooking.actualDimension.height = $event)),
                        withIcon: false,
                        error: _ctx.isErrorInputStepThree.dimension,
                        errorCaption: 'Dimensi wajib diisi',
                        onInput: _ctx.calculationVolumeWeight,
                        onChange: _ctx.onChangeDimension
                      }, null, 8, ["length", "width", "height", "error", "onInput", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "Total Berat Volume Kargo Aktual",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        onChange: _ctx.onChangeTotalCargoVolumeWeight,
                        modelValue: _ctx.formBooking.actualTotalCargoVolumeWeight,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formBooking.actualTotalCargoVolumeWeight = $event)),
                        isErrorIconInput: false,
                        isErrorIconCaption: false,
                        suffix: "Kg",
                        error: _ctx.isErrorInputStepThree.volumeWeight,
                        errorCaption: "Total berat volume kargo aktual wajib diisi",
                        format: _ctx.formatFloat,
                        onBlur: _cache[8] || (_cache[8] = (e) => _ctx.formatValue(e, 'volumeWeight'))
                      }, null, 8, ["onChange", "modelValue", "error", "format"])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 5 }, [], 64)),
            (_ctx.isCargoTrain || _ctx.isCargoShip)
              ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('No. Kargo'),
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpInput, {
                        onChange: _ctx.onChangeCargoNumber,
                        modelValue: _ctx.formBooking.cargoNumber,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formBooking.cargoNumber = $event)),
                        placeholder: _ctx.$t('Masukan No. kargo')
                      }, null, 8, ["onChange", "modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('No. Seri Kendaraan'),
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpInput, {
                        onChange: _ctx.onChangeVehicleNumber,
                        modelValue: _ctx.formBooking.vehicleNumber,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formBooking.vehicleNumber = $event)),
                        placeholder: _ctx.$t('Masukan No. seri kendaraan')
                      }, null, 8, ["onChange", "modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Produk Kargo'),
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Select, {
                        onOpenSelect: _ctx.onOpenSelectCargoProduct,
                        onCloseSelect: _ctx.onCloseSelectCargoProduct,
                        isOpenMenu: _ctx.isOpenSelectCargoProduct,
                        value: _ctx.formBooking.cargoProduct,
                        onChooseSelect: _ctx.onSelectCargoProduct,
                        dataSelect: _ctx.listProductCargo,
                        class: "w-full whitespace-no-wrap my-2 z-10"
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Bukti Foto perubahan berat')
                  }, {
                    default: _withCtx(() => [
                      (_ctx.photoProof.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.photoProof, (photo, index) => {
                                return (_openBlock(), _createBlock("button", {
                                  key: index,
                                  class: "relative flex flex-col p-1 items-center justify-center rounded-xl bg-gray-lp-1000",
                                  style: {"width":"40px","height":"40px"}
                                }, [
                                  _createVNode("img", {
                                    src: photo,
                                    class: "h-full w-full object-cover rounded",
                                    alt: "result-image"
                                  }, null, 8, ["src"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_10, " - "))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.isProcessFromRTC)
              ? (_openBlock(), _createBlock(_Fragment, { key: 7 }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Total Berat Kotor Kargo Aktual",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        onChange: _ctx.onChangeTotalCargoGrossWeight,
                        error: _ctx.isErrorInputStepThree.grossWeight,
                        isErrorIconInput: false,
                        isErrorIconCaption: false,
                        errorCaption: "Total berat kotor kargo aktual wajib diiisi",
                        modelValue: _ctx.formBooking.actualTotalCargoGrossWeight,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formBooking.actualTotalCargoGrossWeight = $event)),
                        suffix: "Kg",
                        format: _ctx.formatFloat,
                        onBlur: _cache[12] || (_cache[12] = (e) => _ctx.formatValue(e, 'grossWeight'))
                      }, null, 8, ["onChange", "error", "modelValue", "format"])
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_DataWrapper, {
                      label: "Total Koli Aktual",
                      asterisk: "",
                      class: "w-3/5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          onChange: _ctx.onChangeTotalColi,
                          error: 
                _ctx.isErrorInputStepThree.totalPieces ||
                  _ctx.isErrorDiffPiecesActualThanDimensionPieces
              ,
                          isErrorIconInput: false,
                          isErrorIconCaption: _ctx.isErrorDiffPiecesActualThanDimensionPieces,
                          errorCaption: 
                _ctx.isErrorDiffPiecesActualThanDimensionPieces
                  ? 'Total STT Berubah, sesuaikan dimensi koli'
                  : 'Total koli aktual wajib diisi'
              ,
                          modelValue: _ctx.formBooking.actualTotalSTTPieces,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formBooking.actualTotalSTTPieces = $event)),
                          format: _ctx.formatNumberOnly
                        }, null, 8, ["onChange", "error", "isErrorIconCaption", "errorCaption", "modelValue", "format"])
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode("div", _hoisted_12, [
                      _createVNode(_component_lp_button, {
                        onClick: _cache[14] || (_cache[14] = () => _ctx.showPopupDimensionPieces(true)),
                        title: "Dimensi Koli",
                        outline: "",
                        textColor: "red-lp-100",
                        iconLeft: "icon-edit-dash"
                      })
                    ], 512), [
                      [_vShow, !_ctx.showButtonDimension]
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.isCargoPlaneAuto)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 8,
                  label: _ctx.$t('No. Penerbangan'),
                  value: _ctx.vehicleNumber,
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.errorAwb)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          onChange: _ctx.onChangeVehicleNumber,
                          modelValue: _ctx.formBooking.vehicleNumber,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formBooking.vehicleNumber = $event)),
                          placeholder: _ctx.$t('Masukan nomor penerbangan')
                        }, null, 8, ["onChange", "modelValue", "placeholder"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "value"]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (_ctx.isShowPopupDimensionPieces)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode(_component_PopupDetailKoli, { formDetailPieces: _ctx.formDetailPieces }, null, 8, ["formDetailPieces"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}